"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var EventArgs_1 = require("../../../models/EventArgs");
var Checkbox = /** @class */ (function (_super) {
    __extends(Checkbox, _super);
    function Checkbox(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isChecked: _this.props.data.value ? _this.props.data.value : false,
        };
        _this.componentDidMount = function () {
            var data = _this.props.data;
            var groupValues = data.groupValues, text = data.text, value = data.value;
            var checked = value;
            if (data && groupValues) {
                checked = groupValues.includes(text);
            }
        };
        _this.componentWillReceiveProps = function (nextProps) {
            var data = nextProps.data;
            var groupValues = data.groupValues, text = data.text, value = data.value;
            var checked = value;
            if (data && groupValues) {
                checked = groupValues.includes(text);
            }
            var isChecked = _this.state.isChecked;
            if (checked !== isChecked) {
                _this.setState({ isChecked: checked });
            }
        };
        _this.onCheckboxStateChange = function (event) {
            var currentTarget = event.currentTarget;
            var checked = currentTarget.checked;
            var _a = _this.props, data = _a.data, events = _a.events;
            var text = data.text;
            _this.setState({ isChecked: checked }, function () {
                var onCheckboxChange = events.onCheckboxChange;
                onCheckboxChange(new EventArgs_1.default(checked), text);
            });
            if (events.notifyGroup) {
                var notifyGroup = events.notifyGroup;
                notifyGroup(text, checked);
            }
        };
        _this.getCheckBoxClasses = function () {
            var e_1, _a;
            var options = _this.props.options;
            var checkClasses = [
                options.classNames
                    ? options.classNames.customCheckBox
                        ? options.classNames.customCheckBox
                        : ""
                    : "",
                "checkbox",
                "flex-items-top",
            ];
            if (_this.props.globalClasses) {
                try {
                    for (var _b = __values(_this.props.globalClasses), _c = _b.next(); !_c.done; _c = _b.next()) {
                        var globalClasses = _c.value;
                        checkClasses.push(globalClasses);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            if (options.error) {
                checkClasses.push("error");
            }
            return checkClasses.join(" ");
        };
        _this.getCheckInputClasses = function () {
            var options = _this.props.options;
            var inputClasses = [
                options.classNames
                    ? options.classNames.customCheckboxInput
                        ? options.classNames.customCheckboxInput
                        : ""
                    : "",
            ];
            return inputClasses.join(" ");
        };
        _this.render = function () {
            var isChecked = _this.state.isChecked;
            var _a = _this.props, data = _a.data, options = _a.options, testId = _a.testId;
            var text = data.text;
            return (React.createElement("label", { className: _this.getCheckBoxClasses(), "data-testid": testId, htmlFor: _this.labelId },
                React.createElement("input", { "aria-invalid": options.disabled || options.error ? true : false, "aria-label": options.accessibility ? options.accessibility : text, checked: isChecked, className: _this.getCheckInputClasses(), disabled: options.disabled, id: _this.labelId, onChange: _this.onCheckboxStateChange, required: options.error, type: "checkbox", name: _this.props.name }),
                React.createElement("span", { className: "checkbox-skin" }),
                React.createElement("span", { className: options.error ? ["formfield-label", "error"].join(".") : "", dangerouslySetInnerHTML: {
                        __html: text,
                    } })));
        };
        _this.labelId = _this.guid();
        return _this;
    }
    Checkbox.prototype.guid = function () {
        return "" + this.S4() + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + "-" + this.S4() + this.S4() + this.S4();
    };
    Checkbox.prototype.S4 = function () {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    };
    Checkbox.defaultProps = {
        data: {
            text: "",
            value: false,
        },
        options: {
            classNames: {
                customCheckBox: " ",
                customCheckboxInput: " ",
            },
        },
    };
    return Checkbox;
}(React.Component));
exports.default = Checkbox;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Checkbox/Checkbox.js
// module id = 1664
// module chunks = 8